import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-white py-24 md:py-32">
      <div className="pz-container grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <span className="pz-overline">FAQ</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] leading-tight">
            Answers to<br />common questions.
          </h2>
          <div className="pz-gold-line mt-6" />
          <p className="mt-6 text-slate-600">
            Can&apos;t find what you&apos;re looking for? Drop us a note via the contact form below — we usually reply within a few hours.
          </p>
          <a
            href="#contact"
            data-testid="faq-cta"
            className="mt-8 inline-flex items-center gap-2 font-medium text-[#0F172A] pz-link-underline"
          >
            Ask a question →
          </a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-slate-200 rounded-2xl px-6 bg-white data-[state=open]:border-[#0F172A] data-[state=open]:shadow-md transition-all"
              >
                <AccordionTrigger className="text-left font-display font-medium text-base sm:text-lg text-[#0F172A] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-[15px] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
